<div class="container" *ngIf="partnersContent">
  <div class="columns m-t-gutter p-t-xl p-b-colgap">
    <div class="column is-5">
      <div class="flex flex-column align-start justify-start is-full-height">
        <h2 class="title is-2 m-b-gutter m-t-0">
          {{ partnersContent.subtitle }}
        </h2>

        <div [innerHtml]="partnersContent.richText1"></div>
      </div>
    </div>
    <div class="column is-5 is-offset-2">
      <div class="flex flex-column align-start justify-center is-full-height">
        <figure class="contain has-dots m-b-xxl">
          <img
            src="{{ partnersContent.image1 }}"
            alt="Two person showing recommendation"
          />
        </figure>
        <figure class="contain has-dots m-b-xxl">
          <img
            src="{{ partnersContent.image2 }}"
            alt="OECD Partnerships & implementation"
          />
        </figure>
        <figure class="contain has-dots m-b-xxl">
          <img
            src="{{ partnersContent.image3 }}"
            alt="OECD Partnerships & implementation : handshake"
          />
        </figure>
        <figure class="contain has-dots m-b-xxl">
          <img src="{{ partnersContent.image4 }}" alt="OECD AI Meeting" />
        </figure>
        <figure class="contain has-dots">
          <img src="{{ partnersContent.image5 }}" alt="OECD AI Meeting" />
        </figure>
      </div>
    </div>
  </div>
  <div class="columns">
    <div class="column">
      <hr />
    </div>
  </div>

  <div class="columns">
    <div class="column is-6 is-offset-3 m-b-xxl">
      <div class="flex align-center justify-center">
        <p i18n="@@partnersContactUs" class="p-x-colgap content is-small">
          Contact us if you are interested in becoming a partner of OECD.AI.
        </p>
        <a
          i18n="@@partnersParagraphContactButton"
          routerLink="/contact"
          class="button m-x-colgap"
        >Contact</a
        >
      </div>
    </div>
  </div>
</div>
